import React, { useState } from 'react';
import './collapse.scss';

const Collapse = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={`gogo-collapse ${isOpen ? 'open' : 'closed'}`}>
      <div className="c-header">
        <p className="c-title">{props.title}</p>
        <div className={`icon ${isOpen ? 'open' : 'closed'}`} onClick={() => setIsOpen(!isOpen)}></div>
      </div>
      {
        isOpen &&
        <div className="c-content">{props.content}</div>
      }
    </div>
  )
}

export default Collapse;
